/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const JaneGold = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/JaneGold"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle cx={12} cy={12} r={10} fill="#FFC220" className="Fill-Main" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M18 12a.46.46 0 0 1-.462.461 5.077 5.077 0 0 0-5.077 5.077.461.461 0 1 1-.922 0 5.077 5.077 0 0 0-5.077-5.077.462.462 0 1 1 0-.922 5.077 5.077 0 0 0 5.077-5.077.462.462 0 1 1 .922 0 5.077 5.077 0 0 0 5.077 5.077c.255 0 .462.206.462.461"
      className="Details"
      clipRule="evenodd"
    />
  </svg>
);

export const JaneGoldIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'jane-gold-icon'}
      icon={JaneGold}
      {...props}
      size={size}
    />
  );
};
